/* Yüzük Ölçüsü page: on-screen ring sizer (card calibration + ring circle), ruler method, tabs.
   Sizes and diameters are read from the size chart rows rendered by snippets/joy-size-guide.liquid. Sizes stay
   text: Turkish whole sizes or US half sizes ("7½"), after the theme setting ring_size_system. */
(() => {
  const root = document.querySelector('[data-ring-sizer]');
  if (!root) return;
  const CARD_SHORT = 53.98; // mm, ISO/IEC 7810 ID-1 card, held upright
  const CARD_LONG = 85.6;
  const STORE_KEY = 'joy-px-per-mm';
  const lang = document.documentElement.lang || 'tr';
  const fmt = (value) => value.toLocaleString(lang, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  const rows = [...root.querySelectorAll('[data-ring-size][data-ring-diameter]')]
    .map((row) => ({ size: row.dataset.ringSize, diameter: parseFloat(row.dataset.ringDiameter) }))
    .filter((row) => row.size && row.diameter);
  if (!rows.length) return;

  const read = () => {
    try { return parseFloat(localStorage.getItem(STORE_KEY)) || 0; } catch (error) { return 0; }
  };
  const save = (value) => {
    try { localStorage.setItem(STORE_KEY, String(value)); } catch (error) { /* private mode */ }
  };
  let pxPerMm = read() || 96 / 25.4;
  let diameter = 17.3;

  const card = root.querySelector('[data-sizer-card]');
  const cardRange = root.querySelector('[data-sizer-card-range]');
  const ring = root.querySelector('[data-sizer-ring]');
  const ringRange = root.querySelector('[data-sizer-ring-range]');
  const result = root.querySelector('[data-sizer-result]');
  const detail = root.querySelector('[data-sizer-detail]');
  const nearest = (mm) => rows.reduce((best, row) => (Math.abs(row.diameter - mm) < Math.abs(best.diameter - mm) ? row : best));
  // Filled part of the track in the touch slider style (joy-ring-sizer.css).
  const fill = (range) => {
    const min = Number(range.min);
    range.style.setProperty('--fill', (Number(range.value) - min) / (Number(range.max) - min));
  };

  const render = () => {
    card.style.width = `${CARD_SHORT * pxPerMm}px`;
    card.style.height = `${CARD_LONG * pxPerMm}px`;
    cardRange.value = pxPerMm.toFixed(2);
    fill(cardRange);
    const px = diameter * pxPerMm;
    ring.style.width = `${px}px`;
    ring.style.height = `${px}px`;
    ringRange.value = diameter.toFixed(1);
    fill(ringRange);
    const match = nearest(diameter);
    result.textContent = root.dataset.textResult.replace('[size]', match.size);
    detail.textContent = root.dataset.textDetail
      .replace('[diameter]', fmt(diameter))
      .replace('[circumference]', fmt(Math.PI * diameter));
  };

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  root.querySelectorAll('[data-sizer-card-step]').forEach((button) => button.addEventListener('click', () => {
    pxPerMm = clamp(pxPerMm * (1 + Number(button.dataset.sizerCardStep) * 0.004), 2, 9);
    render();
  }));
  cardRange.addEventListener('input', () => { pxPerMm = Number(cardRange.value); render(); });
  root.querySelectorAll('[data-sizer-ring-step]').forEach((button) => button.addEventListener('click', () => {
    diameter = clamp(Math.round((diameter + Number(button.dataset.sizerRingStep) * 0.1) * 10) / 10, Number(ringRange.min), Number(ringRange.max));
    render();
  }));
  ringRange.addEventListener('input', () => { diameter = Number(ringRange.value); render(); });
  root.querySelector('[data-sizer-calibrated]').addEventListener('click', () => {
    save(pxPerMm);
    root.querySelector('[data-sizer-measure]').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  root.querySelector('[data-sizer-recalibrate]').addEventListener('click', () => {
    root.querySelector('[data-sizer-calibrate]').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Ruler method: circumference in mm to the nearest size in the chart.
  const ruler = root.querySelector('[data-sizer-ruler]');
  const rulerResult = root.querySelector('[data-sizer-ruler-result]');
  ruler.addEventListener('input', () => {
    const length = parseFloat(String(ruler.value).replace(',', '.'));
    if (!length) { rulerResult.textContent = ''; return; }
    const first = rows[0];
    const last = rows[rows.length - 1];
    if (length < Math.PI * first.diameter - 1.5 || length > Math.PI * last.diameter + 1.5) {
      rulerResult.textContent = root.dataset.textOut;
      return;
    }
    rulerResult.textContent = root.dataset.textRuler.replace('[size]', nearest(length / Math.PI).size);
  });

  // Tabs
  const tabs = [...root.querySelectorAll('[data-sizer-tab]')];
  const select = (tab) => {
    tabs.forEach((item) => {
      const active = item === tab;
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
      document.getElementById(item.getAttribute('aria-controls')).hidden = !active;
    });
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => select(tab));
    tab.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      const next = tabs[(index + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
      select(next);
      next.focus();
    });
  });
  select(tabs[0]);
  render();
})();
